export default __webpack_public_path__ + "static/aditya-chatterjee-graduates-lfx-meshery-program-fae521379ca87547831b66336396ca9a.webp";